import { render, staticRenderFns } from "./ElectricVehicles.vue?vue&type=template&id=54511538&"
import script from "./ElectricVehicles.vue?vue&type=script&lang=js&"
export * from "./ElectricVehicles.vue?vue&type=script&lang=js&"
import style0 from "./ElectricVehicles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports